import { useEffect, useRef, useState } from "react";
import { ProgressBar as RBProgressBar } from "react-bootstrap";
import {
  FaCheckCircle,
  FaListUl,
  FaClock,
  FaTimesCircle,
  FaCalendarAlt,
} from "react-icons/fa";
import { msToTime } from "../../../shared/utils/time";

const PracticeStatsBar = ({
  correct = 0,
  incorrect = 0,
  attempted = 0,
  total = 0,
  timeSpend = 0,
  progress = 0,
  createdAt,
}) => {
  const [time,setTime] = useState(timeSpend);
  const intervalRef = useRef();

  useEffect(() => {
    if (!total) return;
    intervalRef.current = setTimeout(() => {
      setTime((prevTime) => prevTime + 1000);
    }, 1000);

    return () => {
      clearTimeout(intervalRef.current);
    };
  }, [time]);

  const getDate = () =>
    createdAt
      ? new Date(createdAt).toLocaleDateString("en-US")
      : "";

  return (
    <div className="compact-bar w-100 px-2 py-2">

  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

   <div className="stat-pill stat-success">
  <FaCheckCircle className="stat-icon" />
  <span className="d-none d-md-inline">Correct</span>
  <span className="stat-value">{correct}</span>
</div>

<div className="stat-pill stat-danger">
  <FaTimesCircle className="stat-icon" />
  <span className="d-none d-md-inline">Incorrect</span>
  <span className="stat-value">{incorrect}</span>
</div>

<div className="stat-pill stat-primary">
  <FaListUl className="stat-icon" />
  <span className="d-none d-md-inline">Attempted</span>
  <span className="stat-value">{attempted}/{total}</span>
</div>

<div className="stat-pill stat-time">
  <FaClock className="stat-icon" />
  <span className="d-none d-md-inline">Time</span>
  <span className="stat-value">{msToTime(time)}</span>
</div>

{createdAt && (
  <div className="stat-pill stat-date">
    <FaCalendarAlt className="stat-icon" />
    <span className="d-none d-md-inline">Started</span>
    <span className="stat-value">{getDate()}</span>
  </div>
)}

    {/* Progress */}
    
  </div>

<div className="mt-2" style={{display:"flex",gap:"10px", alignItems:"center"}}>
  <RBProgressBar
    now={progress}
    className="w-100 custom-progress rounded-pill"
  />
  <div className="progress-text">
      {progress}%
    </div>
  </div>
</div>
  );
};

export default PracticeStatsBar;